export default {
  labels: {
    page: 'Pagina {{current}} di {{total}}',
    no_file_specified: 'Nessun file specificato',
  },
  buttons: {
    previous: 'Precedente',
    next: 'Successivo',
  },
};
